/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-syntax */
/* eslint-disable eqeqeq */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-unused-vars */
/* eslint-disable no-alert */
/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable import/no-cycle */
import React, { useRef, useState, useEffect } from 'react';
import { DialogUtility, Tooltip } from '@syncfusion/ej2-popups';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { AccordionComponent } from '@syncfusion/ej2-react-navigations';
import { UploaderComponent } from '@syncfusion/ej2-react-inputs';

import {
  GridComponent,
  Inject,
  ColumnsDirective,
  ColumnDirective,
  Search,
  Group,
  Page,
  Selection, Toolbar, Edit, Sort, Filter, Resize, ForeignKey,
} from '@syncfusion/ej2-react-grids';
import { Query } from '@syncfusion/ej2-data';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { useNavigate } from 'react-router-dom';
import { useStateContext } from '../contexts/ContextProvider';

// import axios from 'axios';
import { Header } from '.';
// import { Methods } from '../pages/Methods';
import { langData } from '../data/dummy';

import '../pages/Zackat.css';

const Recordings = () => {
  const navigate = useNavigate();
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=recordings');
    return <p>Please login... </p>;
  }
  const { zRenderMode, isMobile } = useStateContext();
  let uploadObj;
  const [data, setData] = useState([]);
  const [recordings, setRecordings] = useState([]);
  const [rimport, setImport] = useState(false);
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(true);
  const [selUploadOrganization, setUploadOrganization] = useState('');
  const [selUploadOrganizationId, setUploadOrganizationId] = useState('');
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);
  const toolbarOptions = ['Search', 'Add', 'Delete'];
  const { REACT_APP_API_ENDPOINT } = process.env;
  const selectionSettings = { mode: 'Row', type: 'Single' };

  const recordingpath = {
    removeUrl: `${REACT_APP_API_ENDPOINT}/recordingsremove`,
    saveUrl: `${REACT_APP_API_ENDPOINT}/recordingsupload`,
  };
  const buttons = { browse: 'Choose File', clear: 'Clear All', upload: 'Upload All' };
  function completeUpload(args) {
    DialogUtility.alert(`Upload ${args.fileData[0].status}`);
    setReload(!reload);
  }
  const onFileUpload = (args) => {
    // add addition data as key-value pair.
    if (!selUploadOrganizationId || selUploadOrganizationId === '' || selUploadOrganization.length === 0 || selUploadOrganizationId.length === 0) {
      args.cancel = true;
      DialogUtility.alert('Please select an Organization for this recording!');
      return;
    }
    if (!confirm(`Upload to ${selUploadOrganization}`)) {
      args.cancel = true;
      return;
    }
    args.customFormData = [{ organizationid: selUploadOrganizationId }];
  };
  function customiseCell(args) {
    if (!args || !args.column || !args.column.headerText || args.column.headerText !== 'Name') {
      return null;
    }
    const content = `<div>Name: ${args.data.name}<br />Size: ${args.data.length} </div>`;
    const thistooltip = new Tooltip({
      width: '200px',
      height: '80px',
      // <img src=${heartrate} style="display: inline-block;" width="30px" height="30px" />
      // ${args.data.bloodpressure ? args.data.bloodpressure.reading : ''}<sub class="supsm">sys/dia</sub>${bpflag}
      content,
    });
    thistooltip.appendTo(args.cell);
  }

  const valuerules = { required: true };
  // { value: 'WAV', id: 'wav' },
  // { value: 'MP3', id: 'mp3' },

  const [fmtData] = useState([
    { value: 'PCM', id: 'pcm' },
  ]);
  let typeData = [
    { value: 'User', id: 'user' },
  ];

  const orgData = [];
  /*
  const start = (e) => {
    const audio = new Audio(`${REACT_APP_API_ENDPOINT}/audiodown?photo=${e.target.id}.mp3`);
    audio.play();
  };
  const startWav = (e) => {
    const audio = new Audio(`${REACT_APP_API_ENDPOINT}/audiodown?photo=${e.target.id}.wav`);
    audio.play();
  };
  const startPCM = (e) => {
    const audio = new Audio(`${REACT_APP_API_ENDPOINT}/audiodown?photo=${e.target.id}.pcm`);
    audio.play();
  };
  */
  const start = (e) => {
    const audio = new Audio(`${REACT_APP_API_ENDPOINT}/audiodown?photo=${e}.mp3`);
    audio.play();
  };
  const startWav = (e) => {
    const audio = new Audio(`${REACT_APP_API_ENDPOINT}/audiodown?photo=${e}.wav`);
    audio.play();
  };
  const startPCMOrig = (e) => {
    const audio = new Audio(`${REACT_APP_API_ENDPOINT}/audiodown?photo=${e}.pcm`);
    audio.play();
  };
  const [isPlaying, setIsPlaying] = useState(false);
  const startPCM = async (e, duration) => {
    if (isPlaying) {
      return;
    }
    setIsPlaying(true);
    try {
      const audio = new Audio(`${REACT_APP_API_ENDPOINT}/audiodown?photo=${e}.pcm`);
      await audio.play();
      setTimeout(() => { setIsPlaying(false); }, duration || 2000);
    } catch (error) {
      console.error('received an error', error);
      setIsPlaying(false);
      DialogUtility.alert('Error downloading recording, please try again later!');
    }
  };

  /*
  const recordPlayTemplate = (props) => (
    <div>
      {(props.format === 'pcm') ? (
        <input type="button" name="download" id={props._id} value="&#x23F5;" onClick={startPCM} />
      ) : (props.format === 'wav') ? (
        <input type="button" name="download" id={props._id} value="&#x23F5;" onClick={startWav} />
      ) : (
        <input type="button" name="download" id={props._id} value="&#x23F5;" onClick={start} />
      )}
    </div>
  );
  */
  const recordPlayTemplate = (props) => (
    <div>
      {(props.format === 'pcm') ? (
        <ButtonComponent cssClass="e-large" iconCss="e-icons e-play" style={{ float: 'left' }} id={props._id} onClick={() => { startPCM(props._id, props.length / 16); }}>Play</ButtonComponent>
      ) : (props.format === 'wav') ? (
        <ButtonComponent cssClass="e-large" iconCss="e-icons e-play" style={{ float: 'left' }} id={props._id} onClick={() => { startWav(props._id); }}>Play</ButtonComponent>
      ) : (
        <ButtonComponent cssClass="e-large" iconCss="e-icons e-play" style={{ float: 'left' }} id={props._id} onClick={() => { start(props._id); }}>Play</ButtonComponent>
      )}
    </div>
  );
  const editing = {
    allowEditing: false,
    allowAdding: true,
    allowDeleting: true,
    showConfirmDialog: true,
    showDeleteConfirmDialog: true,
    mode: 'Dialog',
  };
  const fmtParams = {
    params: {
      actionComplete: () => false,
      allowFiltering: true,
      dataSource: fmtData,
      fields: { value: 'id', text: 'value' },
      query: new Query(),
    },
  };
  const groupOptions = {
    columns: ['organizationid', 'language'], // Initial grouping by ShipCity
    showGroupedColumn: true,
  };
  const langParams = {
    params: {
      actionComplete: () => false,
      allowFiltering: true,
      dataSource: langData,
      fields: { value: 'id', text: 'value' },
      value: 'en-US', // Set 'English' as the default if no value exists
      query: new Query(),
    },
  };

  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    // fetch data
    const recordingFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/recordings?${query}`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json();

      // set state when the data received
      if (mydata && mydata.role && mydata.role.organizations && mydata.role.organizations.permissions && mydata.role.organizations.permissions.includes('Import')) {
        setImport(true);
      } else {
        setImport(false);
      }
      setData(mydata);
      setRecordings(mydata.recordings);
      setLoading(false);
    };
    recordingFetch();
  }, [reload]);

  const grid = useRef(null);
  const actionBegin = (args) => {
    if (grid && grid.current) {
      const cols = grid.current.columns;
      for (const col of cols) {
        if (args.requestType === 'add') {
          if (col.headerText === 'ID' || col.headerText === 'Translation') {
            col.visible = false;
          } else {
            col.visible = true;
          }
        } else if (col.headerText === 'ID' && args.requestType === 'sorting') {
          col.visible = true;
        } else {
          col.visible = true;
        }
      }
    }
  };
  const actionComplete = (args) => {
    if (args.requestType === 'save' && args.form && args.action === 'add') {
      if (args.data && args.data.name && args.data.tts) {
        // The default edit operation is cancelled
        // Here you can send the updated data to your server using AJAX call
        orgData.forEach((element) => {
          if (element.id === args.data.organizationid) {
            args.data.organizationid = element.id;
            args.data.organization = element.value;
          }
        });
        langData.forEach((element) => {
          if (element.value == args.data.language) {
            element.language = element.id;
          }
        });
        fmtData.forEach((element) => {
          if (element.value == args.data.format) {
            element.format = element.id;
          }
        });
        fetch(`${REACT_APP_API_ENDPOINT}/recordings`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The added/edited data will be saved in the Grid
            if (responseJson && responseJson._id) {
              args.data._id = responseJson._id;
              args.data.tts = responseJson.tts;
              const rowInfo = args.data;
              grid.current.setRowData(responseJson._id, rowInfo.rowData);
              DialogUtility.alert(`Recording has been added ${args.data.name}!`);
              setReload(!reload);
              // window.location.reload();
            }
          })
          .catch((error) => {
            DialogUtility.alert('An error has occured during Insert!');
          });
      }
    } else if (args.requestType === 'delete') {
      let entry = ' this entry?';
      if (args.data.length > 1) {
        entry = ' these entries?';
      }
      if (args.data) {
        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/recordings`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then(() => {
            // The added/edited data will be saved in the Grid
            // The default edit operation is cancelled
            DialogUtility.alert('Recording has been removed!');
          })
          .catch((error) => {
            DialogUtility.alert('An error has occured during Delete!');
          });
      } else {
        args.cancel = false;
      }
    }
  };
  if (loading) {
    return <p>Loading... </p>;
  }
  if (data.systemType) {
    typeData = data.systemType;
  }
  const typeParams = {
    params: {
      actionComplete: () => false,
      allowFiltering: true,
      dataSource: typeData,
      fields: { value: 'id', text: 'value' },
      query: new Query(),
    },
  };
  data.organization.forEach((org) => {
    orgData.push({ id: org._id, value: org.title });
  });
  const organizations = {
    params: {
      actionComplete: () => false,
      allowFiltering: true,
      dataSource: data.organization,
      fields: { value: '_id', text: 'title' },
      query: new Query(),
    },
  };
  return (
    <div className="m-2 md:m-1 mt-2 p-1 md:p-4 bg-white rounded-3xl zackat-divalh">
      <Header category="" title="Recordings" />
      <div id="droparea">
        {rimport && !isMobile && (
        <div className="control-section accordion-control-section" style={{ width: '45%' }}>
          <div className="control Accordion-sample" style={{ margin: '25px 0' }}>
            <AccordionComponent>
              <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-8">
                <div className="e-input-group">
                  <div className="mt-4"> Import </div>
                </div>
                <div className="mt-2 e-input-group">
                  <div>
                    <DropDownListComponent id="ddlelement" cssClass="e-outline" dataSource={organizations.params.dataSource} fields={organizations.params.fields} placeholder="Select Organization" value={selUploadOrganizationId} onChange={(v) => { setUploadOrganizationId(v.value); setUploadOrganization(v.target.itemData.title); }} />
                  </div>
                  <UploaderComponent
                    id="fileupload"
                    type="file"
                    ref={(uplaod) => { uploadObj = uplaod; }}
                    asyncSettings={recordingpath}
                    buttons={buttons}
                    multiple={false}
                    actionComplete={completeUpload}
                    autoUpload={false}
                    uploading={onFileUpload}
                    allowedExtensions=".csv"
                  />
                </div>
              </div>
            </AccordionComponent>
          </div>
        </div>
        )}
      </div>
      <div className="e-adaptive-demo e-bigger">
        <div className="e-mobile-layout">
          <div className="e-mobile-content">
            <GridComponent
              dataSource={recordings}
              width="auto"
              allowPaging
              allowSorting
              editSettings={editing}
              toolbar={toolbarOptions}
              actionComplete={actionComplete}
              actionBegin={actionBegin}
              selectionSettings={selectionSettings}
              enableHover={false}
              pageSettings={{ pageSize: 25, pageCount: 10 }}
              allowGrouping
              queryCellInfo={customiseCell}
              groupSettings={groupOptions}
              allowResizing
              allowFiltering
              allowTextWrap
              ref={grid}
              enableAdaptiveUI={isMobile}
              rowRenderingMode={zRenderMode}
              enableAltRow
            >
              <ColumnsDirective>
                {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                <ColumnDirective
                  field="_id"
                  headerText="ID"
                  template={recordPlayTemplate}
                  width="100"
                  isPrimaryKey
                  visible
                />
                <ColumnDirective
                  field="name"
                  headerText="Name"
                  width="150"
                  validationRules={valuerules}
                  visible
                />
                <ColumnDirective
                  field="tts"
                  headerText="TTS"
                  width="150"
                  validationRules={valuerules}
                  visible
                />
                <ColumnDirective
                  field="translation"
                  headerText="Translation"
                  width="150"
                  visible
                />
                <ColumnDirective
                  field="format"
                  headerText="Format"
                  width="80"
                  validationRules={valuerules}
                  visible
                  editType="dropdownedit"
                  edit={fmtParams}
                  // foreignKeyField="id"
                  // foreignKeyValue="value"
                  // dataSource={fmtParams.params.dataSource}
                />
                <ColumnDirective
                  field="systype"
                  headerText="Type"
                  width="150"
                  validationRules={valuerules}
                  visible
                  editType="dropdownedit"
                  edit={typeParams}
                  // foreignKeyField="id"
                  // foreignKeyValue="value"
                  // dataSource={typeParams.params.dataSource}
                />
                <ColumnDirective
                  field="language"
                  headerText="Language"
                  width="150"
                  validationRules={valuerules}
                  visible
                  editType="dropdownedit"
                  edit={langParams}
                  // foreignKeyField="id"
                  // foreignKeyValue="value"
                  // dataSource={langParams.params.dataSource}
                />
                <ColumnDirective
                  field="organizationid"
                  headerText="Organization"
                  width="150"
                  textAlign="Center"
                  editType="dropdownedit"
                  // edit={organizations}
                  validationRules={valuerules}
                  visible
                  foreignKeyField="_id"
                  foreignKeyValue="title"
                  dataSource={organizations.params.dataSource}
                />
              </ColumnsDirective>
              <Inject services={[Search, Page, Selection, Toolbar, Edit, Sort, Group, Filter, Resize, ForeignKey]} />
            </GridComponent>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Recordings;
